import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
//import { isString } from "util";
import { Value } from "./value-helper";

export class ValidatorExt extends Validators {
    public static number(): ValidatorFn | null {
        return (control:AbstractControl) : ValidationErrors | null => {
            const givenValue = control.value;
            const isNotNumber = isNaN(givenValue);

            const errorObj = {
                invalidNumber: 'Please enter value in number'
            }

            const emptySpacePattern = new RegExp(/^\s+$/g);
            if (Value.IsNotNullOrUndefined(givenValue) &&
               emptySpacePattern.test(givenValue)) {
                return errorObj;             
            }

            if (givenValue !== undefined && givenValue !== null  && 
                givenValue !== '' &&
                (isNotNumber || givenValue.toString().includes('.'))) {
                return errorObj;
            }

            return null;
        }
    }
    public static validateEmail(): ValidatorFn | null {
        return (control:AbstractControl) : ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            const pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!pattern.test(givenValue)) {
                return {
                    invalidEmail: 'Invalid email format'
                };
            }

            return null;        
        } 
    }

    /**
     * Australian Postcode validator (4 digits)
     */
    public static postcode(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            const postcodePattern = /^\d{4}$/;
            if (!postcodePattern.test(givenValue.toString().trim())) {
                return {
                    invalidPostcode: 'Postcode must be 4 digits'
                };
            }

            return null;
        }
    }

    /**
     * Australian ABN validator (11 digits with checksum validation)
     */
    public static abn(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            // Remove all spaces and non-digit characters
            const abn = givenValue.toString().replace(/\s/g, '');

            // Must be 11 digits
            if (!/^\d{11}$/.test(abn)) {
                return {
                    invalidAbn: 'ABN must be 11 digits'
                };
            }

            // Apply ABN checksum algorithm
            const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
            let sum = 0;

            for (let i = 0; i < 11; i++) {
                const digit = parseInt(abn.charAt(i));
                const weight = weights[i];
                sum += (i === 0 ? digit - 1 : digit) * weight;
            }

            if (sum % 89 !== 0) {
                return {
                    invalidAbn: 'Invalid ABN checksum'
                };
            }

            return null;
        }
    }

    public static abnAcn(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            const value = givenValue.toString().replace(/\s/g, '');
            if (!/^\d{9}$/.test(value) && !/^\d{11}$/.test(value)) {
                return {
                    invalidAbn: 'Enter ABN 11 digits or ACN 9 digits or ARBN 9 digits'
                };
            }

            if (value.length === 11) {
                const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
                let sum = 0;

                for (let i = 0; i < 11; i++) {
                    const digit = parseInt(value.charAt(i));
                    sum += (i === 0 ? digit - 1 : digit) * weights[i];
                }

                return sum % 89 === 0 ? null : { invalidAbn: 'Invalid ABN checksum' };
            }

            // Don't apply ACN checksum algorithm
            /*const weights = [8, 7, 6, 5, 4, 3, 2, 1];
            let sum = 0;

            for (let i = 0; i < 8; i++) {
                sum += parseInt(value.charAt(i)) * weights[i];
            }

            const complement = (10 - (sum % 10)) % 10;
            if (complement !== parseInt(value.charAt(8))) {
                return {
                    invalidAbn: 'Invalid ACN checksum'
                };
            }*/

            return null;
        }
    }

    /**
     * Australian phone number validator (landline)
     * Formats accepted: (02) 1234 5678, 02 1234 5678, 0212345678
     */
    public static phoneNumber(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            // Remove spaces, hyphens, and parentheses
            const phone = givenValue.toString().replace(/[\s()-]/g, '');
            
            // Australian landline: starts with 0, followed by area code (2-8), then 8 digits
            const phonePattern = /^0[2-8]\d{8}$/;
            if (!phonePattern.test(phone)) {
                return {
                    invalidPhone: 'Invalid phone number format'
                };
            }

            return null;
        }
    }

    /**
     * Australian mobile number validator
     * Format: 04xx xxx xxx (must start with 04, followed by 8 digits)
     */
    public static mobileNumber(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            // Remove spaces, hyphens, and parentheses
            const mobile = givenValue.toString().replace(/[\s()-]/g, '');
            
            // Australian mobile: starts with 04, followed by 8 digits
            const mobilePattern = /^04\d{8}$/;
            if (!mobilePattern.test(mobile)) {
                return {
                    invalidMobile: 'Mobile number must start with 04 and be 10 digits'
                };
            }

            return null;
        }
    }

    /**
     * BSB validator (6 digits, with optional dash: 123-456 or 123456)
     */
    public static bsb(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            // Remove dashes
            const bsb = givenValue.toString().replace(/-/g, '');
            
            const bsbPattern = /^\d{6}$/;
            if (!bsbPattern.test(bsb)) {
                return {
                    invalidBsb: 'BSB must be 6 digits'
                };
            }

            return null;
        }
    }

    /**
     * Bank account number validator (6-10 digits)
     */
    public static accountNumber(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            const accountPattern = /^\d{6,10}$/;
            if (!accountPattern.test(givenValue.toString())) {
                return {
                    invalidAccountNumber: 'Account number must be 6-10 digits'
                };
            }

            return null;
        }
    }

    public static numberWithDecimal(): ValidatorFn | null {
        return (control:AbstractControl) : ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue)) {
                return null;
            }

            const emptySpacePattern = new RegExp(/^\s+$/g);
            if (Value.IsNotNullOrUndefined(givenValue) &&
               emptySpacePattern.test(givenValue)) {
                return {
                    invalidNumber: 'Please enter value in number'
                }
            }

            const numberPattern = new RegExp(/^([0-9]){1,}$/g);
            const numberWithDecimalPattern = new RegExp(/^([0-9]){1,}\.([0-9]{1,})$/g);
            const isValid = numberPattern.test(givenValue.toString()) || numberWithDecimalPattern.test(givenValue.toString());
            if (!isValid) {
                return {
                    invalidNumber: 'Please enter value in number'
                }
            }

            return null;
        }
    }

    public static numberWithMultipleDecimals(): ValidatorFn | null {
        return (control:AbstractControl) : ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue)) {
                return null;
            }

            const emptySpacePattern = new RegExp(/^\s+$/g);
            if (Value.IsNotNullOrUndefined(givenValue) &&
               emptySpacePattern.test(givenValue)) {
                return {
                    invalidNumber: 'Please enter value in number'
                }
            }

            // Allow integers and decimals with any number of decimal places
            const numberPattern = new RegExp(/^[0-9]+$/);
            const numberWithDecimalPattern = new RegExp(/^[0-9]+\.[0-9]+$/);
            const isValid = numberPattern.test(givenValue.toString()) || numberWithDecimalPattern.test(givenValue.toString());
            if (!isValid) {
                return {
                    invalidNumber: 'Please enter value in number'
                }
            }

            return null;
        }
    }   
    
    public static validateCode(pattern: RegExp, message?: string): ValidatorFn | null {
        return (control:AbstractControl) : ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue)) {
                return null;
          }
          //if (isString(givenValue))
          if (typeof givenValue === "string"){
                const valuePattern = new RegExp(pattern);
                const isCorrect =  valuePattern.test(givenValue);
                if (!isCorrect) {
                    return {
                        invalid: 'Invalid'
                    }
                }
            }


            return null;
        }        
    }

    /**
     * Name validator
     * - Maximum 25 characters
     * - Only letters, dots (.), and spaces allowed
     * - No numbers
     * - No special characters except . and space
     */
    public static firstName(): ValidatorFn | null {
        return (control: AbstractControl): ValidationErrors | null => {
            const givenValue = control.value;
            if (Value.IsNullOrUndefined(givenValue) || givenValue === '') {
                return null;
            }

            const nameValue = givenValue.toString().trim();

            // Check maximum length
            if (nameValue.length > 25) {
                return {
                    invalidFirstName: 'First name must not exceed 25 characters'
                };
            }

            // Only letters (including Unicode letters), dots, hyphens, and spaces allowed
            // No numbers, no special characters except .,- and space
            const namePattern = /^[a-zA-Z\s.-]+$/;
            if (!namePattern.test(nameValue)) {
                return {
                    invalidFirstName: 'First name can only contain letters, dots, hyphens, and spaces'
                };
            }

            return null;
        }
    }
}
